module.exports = __webpack_public_path__ + "img/meeting_4.5f5f47e8.jpg";